var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "coupon-enter",
      class: _vm.styleType,
      on: { click: _vm.openCouponPop },
    },
    [
      _vm.styleType !== "for-echo"
        ? _c("img", {
            staticClass: "bg",
            attrs: { src: require("./images/coupon_btn_bg.png"), alt: "" },
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "main" },
        [
          _vm.styleType !== "for-echo"
            ? [
                _c("div", { staticClass: "left" }, [
                  _c("img", {
                    staticClass: "money-icon",
                    attrs: { src: _vm.getMatchImg("coins"), alt: "" },
                  }),
                  _vm.maxCoupon
                    ? _c("span", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.$t("lang.giftSign.coupon"))),
                      ])
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "right" }, [
                  _vm.maxCoupon
                    ? _c("div", { staticClass: "coupon-num" }, [
                        _c("i", { staticClass: "num" }, [
                          _vm._v("+" + _vm._s(_vm.maxCoupon.amount)),
                        ]),
                        _c("span", { staticClass: "text" }, [
                          _vm._v(_vm._s(_vm.maxCoupon.title)),
                        ]),
                      ])
                    : _c("div", { staticClass: "no-valid" }, [
                        _vm._v(_vm._s(_vm.$t("lang.intimate.noValidCou"))),
                      ]),
                  _c("img", {
                    staticClass: "arrow",
                    attrs: {
                      src: require("@/assets/packageAssets/common/arrow04.png"),
                      alt: "",
                    },
                  }),
                ]),
              ]
            : [
                _c("div", { staticClass: "left" }, [
                  _c("img", {
                    staticClass: "money-icon",
                    attrs: {
                      src: require("./images/coupon-echo.png"),
                      alt: "",
                    },
                  }),
                  _c("span", { staticClass: "text" }, [
                    _vm._v(_vm._s(_vm.$t("lang.giftSign.coupon"))),
                  ]),
                ]),
                _c("div", { staticClass: "right" }, [
                  _vm.maxCoupon
                    ? _c("div", { staticClass: "coupon-num" }, [
                        _c("span", { staticClass: "text" }, [
                          _vm._v(
                            _vm._s(_vm.$t("lang.coupon.extra")) +
                              " " +
                              _vm._s(_vm.maxCoupon.amount)
                          ),
                        ]),
                        _c("img", { attrs: { src: _vm.getMatchImg("coin") } }),
                      ])
                    : _c("div", { staticClass: "coupon-num no-valid" }, [
                        _c("span", { staticClass: "text" }, [
                          _vm._v(_vm._s(_vm.$t("lang.commonM.k058"))),
                        ]),
                      ]),
                  _c("img", {
                    staticClass: "arrow",
                    attrs: {
                      src: require("./images/arrow-right.png"),
                      alt: "",
                    },
                  }),
                ]),
              ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }